import React, { useState, useRef, useEffect } from 'react'
import Navbar from '../Component/Navbar'
import axiosInstance from '../Api/axiosInstance'

// ── API CONSTANTS ─────────────────────────────────────────────
const API = {
  login: '/enterprise/login',
  generateOtp: '/otp/generateResend',
  verifyOtp: '/otp/verify',
}
const DEFAULT_PASSWORD = '12345678'

// ── STYLES ────────────────────────────────────────────────────
const s = {
  body: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#F5F4E8',
    fontFamily: "'DM Sans', sans-serif",
  },
  main: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 16px',
  },
  card: {
    background: '#fff',
    borderRadius: '28px',
    padding: '52px 44px 44px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 8px 40px rgba(59,61,26,0.10), 0 2px 8px rgba(59,61,26,0.06)',
    position: 'relative',
  },
  topBar: {
    position: 'absolute',
    top: 0, left: '44px', right: '44px',
    height: '3px',
    background: 'linear-gradient(90deg, #6B6F2A, #B5BC4A, #6B6F2A)',
    borderRadius: '0 0 4px 4px',
  },
  icon: {
    width: '48px', height: '48px',
    background: 'linear-gradient(135deg, #6B6F2A, #B5BC4A)',
    borderRadius: '14px',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    margin: '0 auto 24px',
    boxShadow: '0 4px 16px rgba(139,148,40,0.18)',
  },
  h1: {
    fontFamily: 'Georgia, serif',
    fontSize: '2rem',
    fontWeight: '700',
    color: '#3B3D1A',
    textAlign: 'center',
    letterSpacing: '-0.5px',
    marginBottom: '6px',
  },
  subtitle: {
    textAlign: 'center',
    fontSize: '0.9rem',
    color: '#7A7C50',
    fontWeight: '300',
    marginBottom: '36px',
  },
  label: {
    display: 'block',
    fontSize: '0.78rem',
    fontWeight: '600',
    color: '#6B6F2A',
    marginBottom: '6px',
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
  },
  inputWrapper: { position: 'relative', marginBottom: '16px' },
  prefix: {
    position: 'absolute',
    left: '16px', top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex', alignItems: 'center', gap: '6px',
    fontSize: '0.9rem',
    color: '#6B6F2A',
    fontWeight: '500',
    pointerEvents: 'none',
  },
  prefixDiv: { width: '1px', height: '18px', background: '#E8ECBF', marginLeft: '4px' },
  input: {
    width: '100%',
    padding: '15px 16px',
    border: '1.5px solid #E8ECBF',
    borderRadius: '14px',
    fontSize: '1rem',
    fontFamily: "'DM Sans', sans-serif",
    color: '#1E1F0C',
    background: '#F5F4E8',
    outline: 'none',
    letterSpacing: '0.5px',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s, box-shadow 0.2s',
  },
  inputPhone: { paddingLeft: '80px' },
  hint: {
    fontSize: '0.78rem',
    color: '#7A7C50',
    marginBottom: '24px',
    paddingLeft: '2px',
    display: 'flex', alignItems: 'center', gap: '5px',
  },
  errorHint: { color: '#c0392b' },
  btn: {
    width: '100%',
    padding: '17px',
    background: 'linear-gradient(135deg, #6B6F2A 0%, #8B9428 60%, #B5BC4A 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '14px',
    fontSize: '1rem',
    fontWeight: '600',
    fontFamily: "'DM Sans', sans-serif",
    letterSpacing: '0.5px',
    cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(107,111,42,0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'opacity 0.2s, transform 0.15s',
  },
  btnDisabled: { opacity: 0.65, cursor: 'not-allowed' },
  footer: {
    textAlign: 'center',
    fontSize: '0.75rem',
    color: '#BBBF8A',
    marginTop: '20px',
  },
  link: { color: '#8B9428', textDecoration: 'none', fontWeight: '500' },
  backBtn: {
    background: 'none',
    border: 'none',
    color: '#6B6F2A',
    fontSize: '0.85rem',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '20px',
    padding: 0,
    fontFamily: "'DM Sans', sans-serif",
  },
  otpRow: {
    display: 'flex',
    gap: '10px',
    marginBottom: '16px',
    justifyContent: 'center',
  },
  otpBox: {
    width: '48px', height: '56px',
    border: '1.5px solid #E8ECBF',
    borderRadius: '12px',
    fontSize: '1.4rem',
    fontWeight: '700',
    textAlign: 'center',
    background: '#F5F4E8',
    color: '#3B3D1A',
    outline: 'none',
    fontFamily: "'DM Sans', sans-serif",
    transition: 'border-color 0.2s, box-shadow 0.2s',
  },
  resend: {
    textAlign: 'center',
    fontSize: '0.82rem',
    color: '#7A7C50',
    marginBottom: '24px',
  },
  resendBtn: {
    background: 'none',
    border: 'none',
    color: '#8B9428',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.82rem',
    padding: 0,
  },
  errorBox: {
    background: '#FEF2F2',
    border: '1px solid #FECACA',
    borderRadius: '12px',
    padding: '14px 16px',
    marginBottom: '16px',
    fontSize: '0.85rem',
    color: '#c0392b',
    fontWeight: '500',
  },
  infoBox: {
    background: '#EEF4DC',
    border: '1px solid #B5BC4A',
    borderRadius: '12px',
    padding: '14px 16px',
    marginBottom: '16px',
    fontSize: '0.85rem',
    color: '#3B3D1A',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  stepIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    marginBottom: '28px',
  },
  stepDot: {
    width: '8px', height: '8px',
    borderRadius: '50%',
    background: '#E8ECBF',
    transition: 'all 0.3s',
  },
  stepDotActive: { background: '#6B6F2A', width: '24px', borderRadius: '4px' },
  stepDotDone: { background: '#B5BC4A' },
}

const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { -webkit-font-smoothing: antialiased; }

  .nav {
    height: 64px;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 60px;
    background: #fff;
    border-bottom: 1px solid #E8ECBF;
    position: sticky; top: 0; z-index: 200;
    box-shadow: 0 2px 12px rgba(59,61,26,0.06);
  }
  .nav-brand {
    display: flex; align-items: center; gap: 10px;
    font-family: 'Sora', sans-serif; font-size: 19px; font-weight: 800;
    color: #3B3D1A; letter-spacing: -0.5px; text-decoration: none;
  }
  .nav-brand-dot {
    width: 7px; height: 7px; border-radius: 50%;
    background: linear-gradient(135deg, #6B6F2A, #B5BC4A);
    display: inline-block; margin-left: 1px;
  }
  .nav-logo {
    width: 32px; height: 32px;
    background: linear-gradient(135deg, #6B6F2A, #B5BC4A);
    border-radius: 9px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .nav-links { display: flex; gap: 36px; list-style: none; align-items: center; }
  .nav-links a {
    font-family: 'DM Sans', sans-serif; font-size: 15px; font-weight: 500;
    color: #5A5C38; text-decoration: none; transition: color 0.2s;
  }
  .nav-links a:hover { color: #6B6F2A; }
  .nav-cta {
    background: linear-gradient(135deg, #6B6F2A, #8B9428); color: #fff;
    font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 600;
    padding: 10px 22px; border-radius: 10px; border: none; cursor: pointer;
    box-shadow: 0 3px 12px rgba(107,111,42,0.30); transition: box-shadow 0.2s, transform 0.15s;
  }
  .nav-cta:hover { box-shadow: 0 5px 18px rgba(107,111,42,0.40); transform: translateY(-1px); }

  .otp-input:focus { border-color: #8B9428 !important; box-shadow: 0 0 0 3px rgba(139,148,40,0.15) !important; }
  .phone-input:focus { border-color: #8B9428 !important; box-shadow: 0 0 0 3px rgba(139,148,40,0.15) !important; }

  @keyframes slideIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
  .slide-in { animation: slideIn 0.3s ease both; }

  @keyframes spin { to { transform: rotate(360deg); } }
  .spin-svg { animation: spin 0.7s linear infinite; transform-origin: center; }

  @media (max-width: 640px) {
    .nav { padding: 0 20px; }
    .nav-links { display: none; }
  }
`

// ── SHARED COMPONENTS ─────────────────────────────────────────
const ArrowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="rgba(255,255,255,0.85)">
    <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z" />
  </svg>
)

const InfoIcon = ({ color }) => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill={color} style={{ flexShrink: 0 }}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
  </svg>
)

const Spinner = ({ size = 20, color = 'white' }) => (
  <svg className="spin-svg" width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="10" strokeDasharray="40 20" />
  </svg>
)

// ── STEP 1: PHONE
// Flow: Login API → if userDoesNotExists error → stop with message
//                 → if success (user exists)   → Generate OTP → go to OTP step
// ─────────────────────────────────────────────────────────────
const PhoneStep = ({ onOtpSent }) => {
  const [phone, setPhone] = useState('')
  const [error, setError] = useState('')
  const [status, setStatus] = useState('') // '' | 'checking' | 'sending'
  const loading = status !== ''

  const handleLogin = async () => {
    if (phone.length !== 10) { setError('Please enter a valid 10-digit number'); return }
    setError('')

    // ── Step A: Login API ─────────────────────────────────────
    setStatus('checking')
    try {
      const loginRes = await axiosInstance.post(API.login, {
        
        body: JSON.stringify({ phoneNumber: phone, password: DEFAULT_PASSWORD }),
      })
      const loginData = await loginRes.json()

      // ✅ Save token from LOGIN response
      if (loginData?.token) {
        localStorage.setItem('token', loginData.token)
        localStorage.setItem('userData', JSON.stringify(loginData.userData))
        localStorage.setItem('enterpriseData', JSON.stringify(loginData.enterprises))
      }

      // Read message from body — API may return error inside a 2xx or 4xx
      const rawMsg = (loginData?.message || loginData?.error || '').toLowerCase()
      const isNotFound =
        rawMsg.includes('userdoesnotexist') ||
        rawMsg.includes('user does not exist') ||
        rawMsg.includes('not found') ||
        rawMsg.includes('not registered') ||
        rawMsg.includes('no user')

      if (isNotFound) {
        setError('This number is not registered. Please contact your administrator.')
        setStatus('')
        return
      }

      // Any other non-ok HTTP status that isn't "not found" → show error
      if (!loginRes.ok && !isNotFound) {
        setError(loginData?.message || 'Login failed. Please try again.')
        setStatus('')
        return
      }

      // ── Step B: User exists → Generate OTP ───────────────────
      setStatus('sending')
      try {
        const otpRes = await axiosInstance.post(API.generateOtp, {
          body: JSON.stringify({ mobileNumber: phone }),
        })
        const otpData = await otpRes.json()

        if (otpRes.ok) {
          onOtpSent(phone)   // ✅ move to OTP step
        } else {
          setError(otpData?.message || 'Failed to send OTP. Please try again.')
          setStatus('')
        }
      } catch {
        setError('Failed to send OTP. Please check your connection.')
        setStatus('')
      }

    } catch {
      setError('Network error. Please check your connection.')
      setStatus('')
    }
  }

  const btnLabel =
    status === 'checking' ? 'Verifying number…' :
      status === 'sending' ? 'Sending OTP…' : 'Login'

  return (
    <div className="slide-in">
      <div style={s.inputWrapper}>
        <label style={s.label}>Mobile Number</label>
        <div style={{ position: 'relative' }}>
          <span style={s.prefix}>
            🇮🇳 +91 <span style={s.prefixDiv} />
          </span>
          <input
            className="phone-input"
            type="tel"
            placeholder="Enter 10-digit number"
            value={phone}
            maxLength={10}
            onChange={e => { setPhone(e.target.value.replace(/\D/g, '').slice(0, 10)); setError('') }}
            onKeyDown={e => e.key === 'Enter' && !loading && handleLogin()}
            style={{
              ...s.input, ...s.inputPhone,
              borderColor: error ? '#c0392b' : '#E8ECBF',
              boxShadow: error ? '0 0 0 3px rgba(192,57,43,0.12)' : 'none',
            }}
          />
        </div>
      </div>

      {error
        ? <p style={{ ...s.hint, ...s.errorHint }}><InfoIcon color="#c0392b" /> {error}</p>
        : <p style={s.hint}><InfoIcon color="#8B9428" /> Enter your registered mobile number</p>
      }

      {status === 'sending' && (
        <div style={s.infoBox}>
          <Spinner size={16} color="#6B6F2A" />
          Number verified! Sending OTP…
        </div>
      )}

      <button
        style={{ ...s.btn, ...(loading ? s.btnDisabled : {}) }}
        onClick={handleLogin}
        disabled={loading}
      >
        {loading ? <><Spinner /> {btnLabel}</> : <>Login <ArrowIcon /></>}
      </button>
    </div>
  )
}

// ── STEP 2: OTP VERIFY ────────────────────────────────────────
const OtpStep = ({ phone, onSuccess, onBack }) => {
  const [otp, setOtp] = useState(['', '', '', '', '', ''])
  const [error, setError] = useState('')
  const [verifying, setVerifying] = useState(false)
  const [resendLoading, setResend] = useState(false)
  const [timer, setTimer] = useState(30)
  const refs = useRef([])

  useEffect(() => {
    refs.current[0]?.focus()
    const id = setInterval(() => setTimer(t => (t > 0 ? t - 1 : 0)), 1000)
    return () => clearInterval(id)
  }, [])

  const handleOtpChange = (i, val) => {
    if (!/^\d*$/.test(val)) return
    const next = [...otp]
    next[i] = val.slice(-1)
    setOtp(next)
    setError('')
    if (val && i < 5) refs.current[i + 1]?.focus()
  }

  const handleKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !otp[i] && i > 0) refs.current[i - 1]?.focus()
  }

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6)
    if (pasted.length === 6) { setOtp(pasted.split('')); refs.current[5]?.focus() }
  }

  const handleVerify = async () => {
    const otpVal = otp.join('')
    if (otpVal.length !== 6) {
      setError('Please enter the 6-digit OTP')
      return
    }

    setVerifying(true)
    setError('')

    try {
      const res = await axiosInstance.post(API.verifyOtp, {

        body: JSON.stringify({
          mobileNumber: phone,
          otp: Number(otpVal),
        }),
      })

      const data = await res.json()
      console.log('OTP verify response:', data)
      console.log('HTTP status:', res.status)
      // ✅ IMPORTANT FIX HERE
      const isFailed =
        data?.statusCode === 400 ||
        (data?.message || '').toLowerCase().includes('failed')
      console.log('isFailed:', isFailed)
      console.log('token in data:', data?.token)
      if (!isFailed) {
        // ✅ SUCCESS — persist auth data
        if (data?.token) {
          localStorage.setItem('token', data.token)
        }
        if (data?.userData) {
          localStorage.setItem('userData', JSON.stringify(data.userData))
        }
        if (data?.enterprises) {
          localStorage.setItem('enterpriseData', JSON.stringify(data.enterprises))
        }

        onSuccess(data)

        // 🔁 Redirect to home after success
        setTimeout(() => {
          window.location.href = '/dashboard'
        }, 1500)

      } else {
        // ❌ FAILURE
        setError('Login failed. Please try again.')
      }

    } catch {
      setError('Network error. Please check your connection.')
    } finally {
      setVerifying(false)
    }
  }
  const handleResend = async () => {
    setResend(true)
    setError('')
    try {
      await fetch(API.generateOtp, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mobileNumber: phone }),
      })
      setTimer(30)
      setOtp(['', '', '', '', '', ''])
      refs.current[0]?.focus()
    } catch {
      setError('Failed to resend OTP.')
    } finally {
      setResend(false)
    }
  }

  const filled = otp.join('').length === 6

  return (
    <div className="slide-in">
      <button style={s.backBtn} onClick={onBack} disabled={verifying}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6B6F2A"
          strokeWidth="2.5" strokeLinecap="round"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
        Change number
      </button>

      <p style={{ ...s.hint, marginBottom: '20px' }}>
        <InfoIcon color="#8B9428" /> OTP sent to <strong>+91 {phone}</strong>
      </p>

      <div style={s.otpRow} onPaste={handlePaste}>
        {otp.map((digit, i) => (
          <input
            key={i}
            className="otp-input"
            ref={el => refs.current[i] = el}
            type="tel"
            maxLength={1}
            value={digit}
            disabled={verifying}
            onChange={e => handleOtpChange(i, e.target.value)}
            onKeyDown={e => handleKeyDown(i, e)}
            style={{
              ...s.otpBox,
              borderColor: error ? '#c0392b' : digit ? '#8B9428' : '#E8ECBF',
              boxShadow: digit ? '0 0 0 3px rgba(139,148,40,0.10)' : 'none',
              opacity: verifying ? 0.6 : 1,
            }}
          />
        ))}
      </div>

      {error && <div style={s.errorBox}>{error}</div>}

      <div style={s.resend}>
        {timer > 0
          ? <span>Resend OTP in <strong style={{ color: '#6B6F2A' }}>0:{String(timer).padStart(2, '0')}</strong></span>
          : <span>Didn't receive OTP?{' '}
            <button style={s.resendBtn} onClick={handleResend} disabled={resendLoading || verifying}>
              {resendLoading ? 'Sending…' : 'Resend'}
            </button>
          </span>
        }
      </div>

      <button
        style={{ ...s.btn, ...(!filled || verifying ? s.btnDisabled : {}) }}
        onClick={handleVerify}
        disabled={!filled || verifying}
      >
        {verifying ? <><Spinner /> Verifying OTP…</> : <>Verify &amp; Login <ArrowIcon /></>}
      </button>
    </div>
  )
}

// ── SUCCESS ───────────────────────────────────────────────────
const SuccessStep = () => (
  <div className="slide-in" style={{ textAlign: 'center' }}>
    <div style={{
      width: '64px', height: '64px',
      background: 'linear-gradient(135deg, #6B6F2A, #B5BC4A)',
      borderRadius: '50%',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      margin: '0 auto 20px',
      boxShadow: '0 6px 20px rgba(107,111,42,0.35)',
    }}>
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none"
        stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </div>
    <h2 style={{ ...s.h1, fontSize: '1.5rem', marginBottom: '8px' }}>Login Successful!</h2>
    <p style={s.subtitle}>Welcome back. Redirecting you now…</p>
  </div>
)

const STEP_META = [
  { title: 'Welcome Back', subtitle: 'Sign in with your mobile number' },
  { title: 'Verify OTP', subtitle: 'Enter the 6-digit code we sent you' },
  { title: "You're in!", subtitle: '' },
]

// ── MAIN ──────────────────────────────────────────────────────
const Login = () => {
  const [step, setStep] = useState(0)
  const [phone, setPhone] = useState('')
  const [loginData, setLoginData] = useState(null)
  const meta = STEP_META[step]

  return (
    <div style={s.body}>
      <style>{globalCSS}</style>

      <Navbar />

      <main style={s.main}>
        <div style={s.card}>
          <div style={s.topBar} />

          <div style={s.icon}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="white">
              <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20C19 20 22 3 22 3c-1 2-8 2-5 8Z" />
            </svg>
          </div>

          {step < 2 && (
            <div style={s.stepIndicator}>
              {[0, 1].map(i => (
                <div key={i} style={{
                  ...s.stepDot,
                  ...(i === step ? s.stepDotActive : {}),
                  ...(i < step ? s.stepDotDone : {}),
                }} />
              ))}
            </div>
          )}

          <h1 style={s.h1}>{meta.title}</h1>
          {meta.subtitle && <p style={s.subtitle}>{meta.subtitle}</p>}

          {step === 0 && <PhoneStep onOtpSent={ph => { setPhone(ph); setStep(1) }} />}
          {step === 1 && (
            <OtpStep
              phone={phone}
              onSuccess={data => { setLoginData(data); setStep(2) }}
              onBack={() => setStep(0)}
            />
          )}
          {step === 2 && <SuccessStep />}

          {step < 2 && (
            <p style={s.footer}>
              By continuing, you agree to our{' '}
              <a href="#" style={s.link}>Terms</a> &amp;{' '}
              <a href="#" style={s.link}>Privacy Policy</a>
            </p>
          )}
        </div>
      </main>
    </div>
  )
}

export default Login